import { useParams } from 'react-router-dom';
import PrintEpaysageAlt from '@repo/print-pdf/epaysage/print-alt';
import { usePrintData } from '@repo/ui/features/inventaires/hooks/use-print-data';
import { Document, pdf } from '@react-pdf/renderer';
import { EpaysagePDF } from '@repo/print-pdf';
import { useState } from 'react';

export default function EpaysagePrintAltStandalonePage() {
  const { id = '' } = useParams<{ id?: string }>();
  const inventaireId = Number(id);
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  if (Number.isNaN(inventaireId)) {
    return <div>Inventaire introuvable</div>;
  }

  // Fetch transformed data from API
  const { data: printData, isLoading, error } = usePrintData(inventaireId);

  const handleDownloadPDF = async () => {
    try {
      if (!printData) {
        alert('Données non disponibles');
        return;
      }

      setIsGeneratingPDF(true);

      // Generate PDF blob with react-pdf using API data
      const blob = await pdf(
        <Document>
          <EpaysagePDF
            data={printData as any}
            epaysageId={inventaireId}
            essences={(printData as any).essence || []}
          />
        </Document>

      ).toBlob();

      // Create download link
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `espace-boisé-${inventaireId || 'fiche'}.pdf`;
      link.click();

      // Cleanup
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Erreur génération PDF:', error);
      alert('Erreur lors de la génération du PDF');
    } finally {
      setIsGeneratingPDF(false);
    }
  };



  // Handle loading and error states
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-lg">Chargement...</p>
      </div>
    );
  }

  if (error || !printData) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-lg text-red-600">
          Erreur lors du chargement des données
          {error && <span className="block text-sm mt-2">{error.message}</span>}
        </p>
      </div>
    );
  }

  return (
    <div className="w-full">
      {/* Action buttons */}
      <div className="print:hidden fixed top-4 right-4 z-50">
        <button
          onClick={() => handleDownloadPDF()}
          className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-md shadow-lg transition-colors"
        >
          {isGeneratingPDF ? 'Génération...' : 'Télécharger PDF'}
        </button>
      </div>

      <PrintEpaysageAlt printData={printData as any} inventaireId={inventaireId} />
    </div>
  );
}

